import _extends from 'babel-runtime/helpers/extends';
import Message from './Message.component';
import mapProps from '../component-helpers/mapProps';

export default mapProps(function (props) {
  return _extends({ style: { color: 'red' } }, props);
}, Message);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-app/node_modules/@dhis2/d2-ui-core/build/es/messages/ErrorMessage.component.js
// module id = 1985
// module chunks = 0